var _path, _path2, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBothLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 16,
    viewBox: "0 0 44 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5039 8.15625H24.5176",
    stroke: "black",
    strokeWidth: 1.00195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0117 4.64844V11.6621",
    stroke: "black",
    strokeWidth: 1.00195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28555_20308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9492 2.33594C36.5117 1.77344 37.5117 1.77344 38.0742 2.33594L41.5117 5.77344C42.0742 6.33594 42.0742 7.33594 41.5117 7.89844L39.1992 10.2109C38.6367 10.7734 37.6367 10.7734 37.0742 10.2109L33.6367 6.77344C33.0742 6.21094 33.0742 5.21094 33.6367 4.64844L35.9492 2.33594Z",
    stroke: "black",
    strokeWidth: 1.08464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9492 5.03125L38.8242 6.90625",
    stroke: "black",
    strokeWidth: 1.08464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0742 7.28125L29.4492 11.9062V13.7812C29.4492 14.1562 29.6992 14.4062 30.0742 14.4062H32.5742V12.5312H34.4492V10.6562H35.6992L36.5742 9.78125",
    stroke: "black",
    strokeWidth: 1.08464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8242 1.90625H4.57422C3.88386 1.90625 3.32422 2.46589 3.32422 3.15625V13.1562C3.32422 13.8466 3.88386 14.4062 4.57422 14.4062H10.8242C11.5146 14.4062 12.0742 13.8466 12.0742 13.1562V3.15625C12.0742 2.46589 11.5146 1.90625 10.8242 1.90625Z",
    stroke: "black",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69922 11.9062H7.70589",
    stroke: "black",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28555_20308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(28.1992 0.65625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBothLogin);
export default __webpack_public_path__ + "static/media/bothLogin.9f37a61e601f438533bcce9047d30fe8.svg";
export { ForwardRef as ReactComponent };